import { auth } from "../../../backend/firebaseConfig";

const API_URL = (process.env.REACT_APP_SNOWFLAKE_API_URL || "http://localhost:10001").replace(/\/$/, "");

export const getFCIStatementsPage = async (
  page,
  pageSize = 1000,
  userEmail = "",
  filters = {},
) => {
  const token = await auth.currentUser?.getIdToken(true);
  if (!token) throw new Error("Please sign in again.");
  const params = new URLSearchParams({ page, pageSize });
  Object.entries(filters).forEach(([key, value]) => {
    if (!value) return;
    if (key === "_sort") params.set("sort", value);
    else if (key === "_direction") params.set("direction", value);
    else if (key === "_search") params.set("search", value);
    else if (key === "_export") params.set("export", value);
    else if (key === "_commissionSummary")
      params.set("includeCommissionSummary", value);
    else if (key === "_paymentDateFrom") params.set("paymentDateFrom", value);
    else if (key === "_paymentDateTo") params.set("paymentDateTo", value);
    else if (key === "_period" || key === "incomePeriodId")
      params.set("incomePeriodId", value);
    else params.set(`filter_${key}`, value);
  });
  const response = await fetch(`${API_URL}/api/fci-statements?${params}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "X-User-Email": userEmail || "",
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok)
    throw new Error(body.error || "Unable to load FCI statements.");
  return body;
};

export const getAllFCIStatements = async (userEmail = "", filters = {}) => {
  const pageSize = 100000;
  const firstPage = await getFCIStatementsPage(1, pageSize, userEmail, filters);
  const rows = [...(firstPage.rows || [])];
  const total = Number(firstPage.total || rows.length);

  for (let page = 2; rows.length < total; page += 1) {
    const nextPage = await getFCIStatementsPage(
      page,
      pageSize,
      userEmail,
      filters,
    );
    const nextRows = nextPage.rows || [];
    if (!nextRows.length) break;
    rows.push(...nextRows);
  }

  return { ...firstPage, rows, total };
};

export const getCurrentFCITotalsByAdviser = async (userEmail = "") => {
  const token = await auth.currentUser?.getIdToken(true);
  if (!token) throw new Error("Please sign in again.");
  const params = new URLSearchParams({ incomePeriodId: "current" });
  const response = await fetch(
    `${API_URL}/api/fci-statements/totals-by-adviser?${params}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-User-Email": userEmail || "",
      },
    },
  );
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.error || "Unable to load IO totals by adviser.");
  }
  return Array.isArray(body.totals) ? body.totals : [];
};

export const getIOIntroducers = async (userEmail = "") => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error("Please sign in again.");
  const response = await fetch(`${API_URL}/api/io-introducers`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "X-User-Email": userEmail || "",
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.error || "Unable to load IO introducers.");
  }
  return Array.isArray(body.rows) ? body.rows : [];
};
